import { render, staticRenderFns } from "./VTypeSelect.vue?vue&type=template&id=b02fd652&scoped=true&"
import script from "./VTypeSelect.vue?vue&type=script&lang=js&"
export * from "./VTypeSelect.vue?vue&type=script&lang=js&"
import style0 from "./VTypeSelect.vue?vue&type=style&index=0&id=b02fd652&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b02fd652",
  null
  
)

export default component.exports